export enum CandidatesCountersScope {
  NoScope = '',
  Last30Days = 'last_30_days',
  Last7Days = 'last_7_days',
  ThisMonth = 'this_month',
  ThisWeek = 'this_week',
}
